import React from 'react';
import { Route, Redirect, withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import { saveAuthReturnUrl } from '../../auth/returnUrl';
import { isLogin, isPublicRouter } from '../../utils';

const RouteWithLayout = ({
  layout: Layout,
  isPublic,
  history,
  component: Component,
  layoutProps,
  componentProps,
  ...rest
}) => {
  const isLoged = isLogin();
  const isRouterPublic = isPublicRouter(history.location.pathname);
  const shouldRedirectToLogin = !isPublic && !isLoged && !isRouterPublic;

  if (shouldRedirectToLogin) {
    saveAuthReturnUrl(`${history.location.pathname}${history.location.search}`);
  }

  return (
    <Route
      {...rest}
      render={matchProps => (
        <Layout {...layoutProps}>
          {shouldRedirectToLogin ? (
            <Redirect to="/v2/login" />
          ) : (
            <Component {...matchProps} {...componentProps} />
          )}
        </Layout>
      )}
    />
  );
};

RouteWithLayout.propTypes = {
  component: PropTypes.any.isRequired,
  layout: PropTypes.any.isRequired,
  history: PropTypes.object.isRequired,
  path: PropTypes.string,
  isPublic: PropTypes.bool,
  layoutProps: PropTypes.object,
  componentProps: PropTypes.object,
};

RouteWithLayout.defaultValue = {
  isPublic: false,
  layoutProps: {},
  componentProps: {},
}

export default withRouter(RouteWithLayout);
